import LoginComponent from '../components/login/login'

function Login() {

    return(
        <>
        <LoginComponent/>
        </>
    )
}
export default Login